module.exports = __webpack_public_path__ + "img/restart.021339dd.svg";